// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "loadColumn": [
            {
                "name": "name",
                "displayName": "{{i18n.name}}",
                "maxWidth": 380,
                "minWidth": 260,
                "width": 200,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "role",
                "displayName": "{{i18n.role}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "team",
                "displayName": "{{i18n.team}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "status",
                "displayName": "{{i18n.status}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "account",
                "displayName": "{{i18n.account}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 100,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "email",
                "displayName": "{{i18n.email}}",
                "maxWidth": 390,
                "minWidth": 200,
                "width": 200,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            }
        ]
    },
    "props": {
        "collaborationspaceid": {
            "type": "string"
        },
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        }
    },
    "dataProviders": {
        "libraryMembersListRowProvider": {
            "action": "listLibraryMembers",
            "response": "{{data.libraryMembers}}",
            "selectionModelMode": "single"
        }
    },
    "columnProviders": {
        "libraryMembersListColumnProvider": {
            "frozenColumnIndex": -1,
            "columns": "{{data.loadColumn}}"
        }
    },
    "grids": {
        "libraryMembersList": {
            "dataProvider": "libraryMembersListRowProvider",
            "columnProvider": "libraryMembersListColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enablePinning": true,
                "enableSorting": false
            }
        }
    },
    "actions": {
        "listLibraryMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListLibraryMembers($listLibraryMembersInput: ListLibraryMembersInput) {listLibraryMembers(listLibraryMembersInput: $listLibraryMembersInput) }",
                        "variables": {
                            "listLibraryMembersInput": {
                                "libraryId": "{{props.libraryid}}",
                                "searchOptions": {
                                    "limit": 10,
                                    "skip": 0,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "libraryMembers": "data.data.listLibraryMembers.membersList"
            },
            "events": {},
            "actionMessages": {},
            "deps": "js/accHttpService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "libraryMembersListRowProvider"
        }
    },
    "onEvent": [
        {
            "eventId": "shareLibraryToUsersSuccess",
            "action": "reveal",
            "cacheEventData": true
        }
    ],
    "i18n": {
        "name": [
            "DesLibraryMessages"
        ],
        "role": [
            "DesLibraryMessages"
        ],
        "team": [
            "DesLibraryMessages"
        ],
        "status": [
            "DesLibraryMessages"
        ],
        "account": [
            "DesLibraryMessages"
        ],
        "email": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesLibraryMembersList",
    "_uniqueViewModelId": "DesLibraryMembersList",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body class="des-library-overview">
        <aw-splm-table gridid="libraryMembersList"></aw-splm-table>
    </aw-panel-body>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody className="des-library-overview">
            <AwSplmTable {...grids.libraryMembersList}>
            </AwSplmTable>
        </AwPanelBody>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;